import React from 'react';
import PropTypes from 'prop-types';

export default function SortButton({ field, label, currentField, direction, onClick }) {
  const isActive = field === currentField;

  return (
    <button
      type="button"
      className={`sort-button ${isActive ? 'active' : ''} ${isActive ? direction : ''}`}
      onClick={() => onClick(field)}
      title={label}
      aria-pressed={isActive}
    >
      {label.replace('Sort by ', '')}
      {isActive && (
        <span className="sort-arrow" aria-label={direction === 'asc' ? 'ascending' : 'descending'}>
          {direction === 'asc' ? '↑' : '↓'}
        </span>
      )}
    </button>
  );
}

SortButton.propTypes = {
  field: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  currentField: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onClick: PropTypes.func.isRequired
};
